/* Restyle Shopify's existing banner; Shopify still records every consent choice. */
(() => {
  const copy = document.currentScript.dataset;
  function compactBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.classList.contains('sam-cookie-banner')) return;
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    if (!preferences || !accept || !decline) return;
    // Keep the original buttons (and their native click/focus handlers).
    preferences.textContent = copy.notice;
    accept.textContent = copy.accept;
    decline.textContent = copy.decline;
    banner.setAttribute('aria-label', copy.notice);
    banner.removeAttribute('aria-labelledby');
    banner.classList.add('sam-cookie-banner');
  }
  compactBanner();
  // Shopify injects the banner asynchronously and replaces it when reopened.
  new MutationObserver(compactBanner).observe(document.body, { childList: true, subtree: true });
})();
